import { injectTranslate } from '@core/i18n-legacy';
import type { IconName } from '@core/user-interface-legacy';
import type { AskTicketStatus } from '@tellent-ask-hr/tickets-types';

export const injectStatusTranslations = () => {
  const t = injectTranslate();
  return {
    open: t('tlc.ask_hr.requests.status_levels.open'),
    in_progress: t('tlc.ask_hr.requests.status_levels.in_progress'),
    closed: t('tlc.ask_hr.requests.status_levels.closed'),
  };
};

export const statusIconMap: Record<AskTicketStatus, IconName> = {
  open: 'archive',
  in_progress: 'refresh',
  closed: 'check',
};
